import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
} from "../../Component";
import { DATE_FORMATS } from "../../../utilities/constants";
import { unixDateConvertor } from "../../../utilities/dateTimeUtils";

const UserDetailsPageHeader = ({
  name,
  createdDate,
  goBackPath,
  onEditClick,
  onDeleteClick,
  isDeleteLoading = false,
  canManageUsers = false,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <BlockHead size="sm">
      <Button
        color="white bg-white"
        outline
        className="mb-3"
        onClick={(e) => {
          e.preventDefault();
          navigate(goBackPath);
        }}
        iconName="arrow-left"
        title="Back"
      />

      <BlockBetween>
        <BlockHeadContent>
          <BlockTitle tag="h3" page noText>
            {t("User -")} <strong className="text-gray">{name}</strong>
          </BlockTitle>
          <BlockDes className="text-soft">
            <ul className="list-inline">
              {createdDate && (
                <li className="mr-5">
                  {t("Created On")}:{" "}
                  <h6>
                    {unixDateConvertor(createdDate, DATE_FORMATS.DATE_TIME)}
                  </h6>
                </li>
              )}
            </ul>
          </BlockDes>
        </BlockHeadContent>

        {canManageUsers && (
          <BlockHeadContent>
            <div className="d-flex">
              <Button
                color="danger"
                className="mr-2"
                iconName="trash"
                aria-label="Delete"
                title="Delete"
                onClick={onDeleteClick}
                isLoading={isDeleteLoading}
              />
              <Button
                color="primary"
                title="Edit"
                iconName="edit-alt"
                aria-label="Edit"
                onClick={(e) => {
                  e.preventDefault();
                  onEditClick?.();
                }}
              />
            </div>
          </BlockHeadContent>
        )}
      </BlockBetween>
    </BlockHead>
  );
};

export default UserDetailsPageHeader;
